import { AUTO_STYLE, animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IMAGE_URLS } from 'src/app/core/constants/image-source';
import { Category } from 'src/app/shared/services/common-api.service';
import { HeaderLayout } from '../../dynamic-header/dynamic-header.component';
import { MenuCollapseService } from '../../dynamic-header/services/menu-collapse.service';
import { DEFAULT_DURATION } from '../../static-menu-collapse/static-sub-menu/static-sub-menu.component';

@Component({
  selector: 'webstore-menu-collapse',
  templateUrl: './menu-collapse.component.html',
  styleUrls: ['./menu-collapse.component.scss'],
  standalone: true,
  animations: [
    trigger('collapse', [
      state('false', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
      state('true', style({ height: '0', visibility: 'hidden' })),
      transition('false => true', animate(DEFAULT_DURATION + 'ms ease-in')),
      transition('true => false', animate(DEFAULT_DURATION + 'ms ease-out'))
    ])
  ],
  imports: [CommonModule, RouterModule]
})
export class MenuCollapseComponent {
  private menuCollapseService = inject(MenuCollapseService);

  readonly menuCollapseIcon = input<string>('');
  readonly sub_category = input<Category | null>(null);
  readonly collapsed = input<boolean>(false);
  readonly headerLayout = input<string>('default');

  // Effective collapsed state considering static menu
  readonly actualCollapsed = computed(() => this.collapsed() || this.menuCollapseService.isStaticMenu());

  // Computed property to check if layout is headerLayout12
  readonly isLayout12 = computed(() => this.headerLayout() === HeaderLayout.headerLayout12);

  HeaderLayout = HeaderLayout; // Exposed enum to template
  IMAGE_URLS = IMAGE_URLS;

  // Update output to use Angular 20 output() function
  hideMenu$ = output<boolean>();
  selectCategory$ = output<string | undefined>();
}

